import React from 'react'
import styled from 'styled-components'
import { FaGift } from 'react-icons/fa'

export type CreditChipTone = 'active' | 'todo' | 'done' | 'skipped'

interface Props {
  amount: number
  tone: CreditChipTone
}

export const CreditChip: React.FC<Props> = ({ amount, tone }) => {
  if (amount <= 0) return null

  return (
    <Chip $tone={tone}>
      <FaGift />
      <Amount>+{amount}</Amount>
    </Chip>
  )
}

const Chip = styled.span<{ $tone: CreditChipTone }>`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  white-space: nowrap;
  flex: 0 0 auto;

  svg {
    width: 0.65rem;
    height: 0.65rem;
  }

  ${({ $tone, theme }) =>
    $tone === 'active'
      ? `
        padding: ${theme.spacing.xxs}rem 0.5rem;
        border-radius: 999px;
        background: ${theme.luca.mist};
        border: 1px solid ${theme.luca.mistBorder};

        svg { color: ${theme.colors.primary}; }
        span { color: ${theme.luca.deepBlue}; }
      `
      : `
        svg, span { color: ${
          $tone === 'done'
            ? theme.dashboard.positive
            : $tone === 'skipped'
            ? theme.colors.borderStrong
            : theme.luca.textMuted
        }; }
      `}
`

const Amount = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  font-family: 'Roboto Mono', ui-monospace, monospace;
  font-variant-numeric: tabular-nums;
`
